// libs
import { setUser as setUserGTM } from 'shared/helpers/analytics';

// defs
import { CustomerData } from 'shared/types/customer';

export const setUser = (customerData: CustomerData | 'GUEST') => {
  setUserGTM(customerData);
};
